import Nullstack from 'nullstack';
export default function IconTopologyBus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-topology-bus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M6 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M22 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
  }), "   ", Nullstack.element("path", {
    d: "M2 16h20"
  }), "   ", Nullstack.element("path", {
    d: "M4 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M20 12v4"
  }), " ");
}